import React from 'react';
import Box from '@mui/material/Box';
import DateTimeInputComponent from '../Date-time-input/Date-time-input.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    timezone,
    fromDateFilter,
    toDateFilter,
    onFromDateChange,
    onToDateChange,
}: IProps) => {
    return (
        <Box className="date-filter">
            <DateTimeInputComponent
                label="fromDate"
                lang={lang}
                timezone={timezone}
                value={fromDateFilter}
                onChange={onFromDateChange}
            />
            <DateTimeInputComponent
                label="toDate"
                lang={lang}
                timezone={timezone}
                value={toDateFilter}
                onChange={onToDateChange}
            />
        </Box>
    );
};

const DateFilterComponent = React.memo(Component);

export default DateFilterComponent;
